module.exports = "./img/desktop_logo.83f9442.png";